(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  // v35 snelheid: na het laden van de pagina (1) uitgestelde beelden altijd tonen (vangnet voor data-nn-defer),
  // (2) de lazy beelden in de verborgen winkelwagenlade en (3) de kleine bundelbeeldjes alvast ophalen,
  // zodat lade en bundelkiezer er direct mee in beeld komen.
  const afterLoad = () => {
    document.querySelectorAll('img[data-nn-defer]').forEach(img => {
      if (img.dataset.nnSrcset) img.srcset = img.dataset.nnSrcset;
      img.src = img.dataset.nnSrc;
      img.removeAttribute('data-nn-defer');
    });
    setTimeout(() => {
      document.querySelectorAll('#paper-cart-overlay img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
      document.querySelectorAll('[data-nnb-card][data-image]').forEach(card => { const img = new Image(); img.src = card.dataset.image; });
    }, 800);
  };
  if (document.readyState === 'complete') afterLoad(); else addEventListener('load', afterLoad, { once: true });
  const hero = document.querySelector('[data-home-slideshow]');
  if (hero) {
    const slides = [...hero.querySelectorAll('[data-home-slide]')];
    const selectors = [...hero.querySelectorAll('[data-home-select]')];
    const pause = hero.querySelector('[data-home-pause]');
    const interval = Number(hero.dataset.interval) || 6000;
    let active = 0, userPaused = false, timer, tick = 0;
    // v35 snelheid: het beeld van de volgende slide laadt pas na de pagina (data-nn-src/data-nn-srcset),
    // en de automatische wissel wacht tot dat beeld er is, zodat er nooit een lege slide in beeld komt.
    const hydrate = slide => {
      slide.querySelectorAll('source[data-nn-srcset]').forEach(source => { source.srcset = source.dataset.nnSrcset; source.removeAttribute('data-nn-srcset'); });
      slide.querySelectorAll('img[data-nn-src]').forEach(img => { img.src = img.dataset.nnSrc; img.removeAttribute('data-nn-src'); });
    };
    const ready = slide => {
      hydrate(slide);
      const img = slide.querySelector('.paper-hero-photo img');
      if (!img || (img.complete && img.naturalWidth > 1)) return Promise.resolve();
      return new Promise(done => {
        const stop = setTimeout(done, 10000);
        const finish = () => { clearTimeout(stop); done(); };
        img.addEventListener('load', finish, { once: true });
        img.addEventListener('error', finish, { once: true });
      });
    };
    const blocked = () => userPaused || motion.matches || document.hidden || hero.contains(document.activeElement) || document.querySelector('#nn-certification-dialog')?.open;
    const schedule = () => {
      clearTimeout(timer);
      const turn = ++tick;
      hero.dataset.playing = String(!blocked());
      if (!blocked()) timer = setTimeout(() => {
        const next = (active + 1) % slides.length;
        ready(slides[next]).then(() => { if (turn === tick) show(next); });
      }, interval);
    };
    const show = index => {
      if (index !== active && slides[active].contains(document.activeElement)) selectors[index].focus({preventScroll:true});
      active = index;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', String(i !== active));
        slide.inert = i !== active;
      });
      selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      hero.dataset.activeSlide = String(active);
      schedule();
    };
    const updatePause = () => {
      const paused = userPaused || motion.matches;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', motion.matches ? 'Automatisch wisselen uit: verminderde beweging' : paused ? 'Hervat de diavoorstelling' : 'Pauzeer de diavoorstelling');
      pause.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
      pause.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
      schedule();
    };
    pause.addEventListener('click', () => { if (!motion.matches) userPaused = !userPaused; updatePause(); });
    selectors.forEach((button, i) => button.addEventListener('click', () => { hydrate(slides[i]); show(i); }));
    hero.addEventListener('focusin', schedule);
    hero.addEventListener('focusout', () => queueMicrotask(schedule));
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', updatePause);
    hero.querySelector('[data-home-controls]').hidden = false;
    show(0);
    updatePause();
    const hydrateAll = () => setTimeout(() => slides.forEach(hydrate), 200);
    if (document.readyState === 'complete') hydrateAll(); else addEventListener('load', hydrateAll, { once: true });
  }

  document.querySelectorAll('[data-card-secondary]').forEach(image => {
    const photo = image.closest('.nn-card-photo');
    const ready = () => photo.classList.toggle('has-secondary', image.complete && image.naturalWidth > 0);
    image.addEventListener('load', ready);
    image.addEventListener('error', () => photo.classList.remove('has-secondary'));
    ready();
  });

  const toggle = document.querySelector('#nn-shop-toggle');
  const menu = document.querySelector('#nn-shop-menu');
  const desktop = matchMedia('(min-width: 1024px)');
  if (toggle && menu) {
    let closing;
    // v35 snelheid: de tegelbeelden zijn lazy (het menu is verborgen); op desktop halen we ze na het laden alvast op.
    const warm = () => menu.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    const warmLater = () => setTimeout(() => { if (desktop.matches) warm(); }, 300);
    if (document.readyState === 'complete') warmLater(); else addEventListener('load', warmLater, { once: true });
    const open = () => {
      if (!desktop.matches) return;
      warm();
      clearTimeout(closing);
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    };
    const close = (restore = false) => {
      clearTimeout(closing);
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (restore) toggle.focus({preventScroll:true});
    };
    const closeSoon = () => { clearTimeout(closing); closing = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 220); };
    toggle.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') open(); });
    toggle.addEventListener('pointerleave', closeSoon);
    menu.addEventListener('pointerenter', () => clearTimeout(closing));
    menu.addEventListener('pointerleave', closeSoon);
    // Shop alles is a normal collection link; hover and ArrowDown reveal the menu.
    toggle.addEventListener('click', () => close());
    toggle.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); open(); menu.querySelector('a')?.focus(); }
    });
    menu.addEventListener('focusin', () => clearTimeout(closing));
    document.addEventListener('focusin', event => {
      if (!menu.hidden && event.target !== toggle && !menu.contains(event.target)) close();
    });
    document.addEventListener('pointerdown', event => {
      if (!menu.hidden && !menu.contains(event.target) && !toggle.contains(event.target)) close();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) { event.preventDefault(); close(menu.contains(document.activeElement) || document.activeElement === toggle); }
    });
    desktop.addEventListener('change', () => {
      close();
      const drawer = document.querySelector('#paper-menu-overlay');
      if (desktop.matches && drawer?.classList.contains('is-open')) drawer.querySelector('[data-action="close-menu"]')?.click();
    });
  }
})();
